import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Input from '../../shared/components/FormElements/Input'
//import Button from '../../shared/components/UIElements/Button'
import AdminButton from '../../shared/components/UIElements/AdminButton'
import { VALIDATOR_REQUIRE } from '../../shared/util/validators'
import './NewPlayerForm.css'
import AdminNavigation from '../../admin/components/AdminNavigation'
import { useForm } from '../../shared/hooks/form-hook'
import { useHttpClient } from '../../shared/hooks/http-hook'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import ImageUpload from '../../shared/components/FormElements/ImageUpload'

const TeamPhotoForm = () => {
	const { isLoading, error, sendRequest, clearError } = useHttpClient()
	const [file, setFile] = useState()
	const [teamName, setTeamName] = useState()
	const [leagueId, setLeagueId] = useState()
	const [divisionName, setDivisionName] = useState()
	const [year, setYear] = useState()
	const [playerId, setPlayerId] = useState()
	const teamId = useParams().teamId
	let navigate = useNavigate()

	//only need setFormData in Update
	const [formState, inputHandler, setFormData] = useForm()

	//call to getTeamDataByTeamId
	//First, we want to get the team name to display on the form
	useEffect(() => {
		const fetchTeamData = async () => {
			try {
				const responseData = await sendRequest(
					`${process.env.REACT_APP_BACKEND_URL}/admin/teamPhoto/${teamId}`,
				)
				setTeamName(responseData.team.teamName)
				setLeagueId(responseData.team.leagueId)
				setDivisionName(responseData.team.divisionName)
				setYear(responseData.team.year)
			} catch (err) {
				console.log('OH NO! ' + err)
			}
		}
		fetchTeamData()
	}, [sendRequest, teamId])
	//
	//
	//
	const onFileChange = (e) => {
		let pickedFile

		if (e.target.files && e.target.files.length === 1) {
			pickedFile = e.target.files[0]
			console.log('pickedFile: ' + pickedFile)
			setFile(pickedFile)
		}
	}
	//
	//
	//Next, we want to make a call to uploadTeamPhoto within the player-controller
	const teamPhotoSubmitHandler = async (event) => {
		console.log('inside teamPhotoSubmitHandler ' + formState.inputs)
		event.preventDefault()
		try {
			const formData = new FormData()

			formData.append('image', formState.inputs.image.value)
			const responseData = await sendRequest(
				process.env.REACT_APP_BACKEND_URL + `/player/${teamId}/teamphoto`,
				'POST',
				formData,
			)
			//navigate(`/league/${leagueId}/${divisionName}/${year}/${teamName}`)
			navigate(`admin/leagues/current`)
		} catch (err) {
			console.log('upload photo error: ' + err)
		}
	}

	if (isLoading) {
		return (
			<div className='center'>
				<LoadingSpinner />
			</div>
		)
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={clearError} />
			{!isLoading && teamName && (
				<div>
					<AdminNavigation />
					<main>
						<h2>Add a Team Photo</h2>
						<h3>
							{teamName} {year}
						</h3>
						<form className='team-form' onSubmit={teamPhotoSubmitHandler}>
							<ImageUpload
								center
								id='image'
								//name='image'
								onInput={inputHandler}
							/>
							<AdminButton type='submit'>ADD TEAM PHOTO</AdminButton>
						</form>
					</main>
				</div>
			)}
		</React.Fragment>
	)
}

export default TeamPhotoForm
